<template>
  <div class="card-radio-offre">
    <label :for="this.offreId">
      <div
        :class="[
          'card-offre',
          this.activeOffre === this.offreId ? 'is-active' : ''
        ]"
      >
        <div class="card-header">
          <img :src="require('@/assets/' + this.offreImg)" /><br />
          {{ this.offreTitre }}
        </div>
        <div class="card-body">
          <p>{{ this.offreText }}</p>
          <p
            v-if="this.offreId != 'NONE'"
            style="font-family:Lato; font-weight: bold; font-size:18px;"
          >
            Inclus dans votre offre
          </p>
          <div
            :class="[
              this.offreId === 'L' || this.offreId === 'ETS'
                ? 'categories-pratique-L-E'
                : this.offreId === 'C'
                ? 'categories-pratique-C'
                : this.offreId.startsWith('V')
                ? 'categories-pratique-V'
                : '',
              'categories-pratique'
            ]"
          >
            <div
              class="categorie-pratique"
              v-for="offre of this.offreListe"
              :key="offre.index"
            >
              <img :src="require('@/assets/' + offre + '.png')" /><br />
              {{ ("libelle_" + offre) | translate(locale) }}
            </div>
          </div>
        </div>
      </div>
    </label>
    <input
      type="radio"
      :id="this.offreId"
      name="offre"
      @change="updateActiveOffre"
      :checked="this.activeOffre === this.offreId"
    />
  </div>
</template>

<script>
import translations from "@/Translations.js";

export default {
  props: {
    offreId: String,
    offreTitre: String,
    offreText: String,
    offreImg: String,
    offreListe: undefined,
    activeOffre: String,
    locale: {
      type: String,
      default: "fr"
    }
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  methods: {
    updateActiveOffre() {
      this.$emit("onUpdateOffre", this.offreId);
    }
  }
};
</script>

<style>
.is-active {
  border: 1px solid #003690 !important;
}

.categorie-pratique {
  margin: 10px 5px;
  max-width: 80px;
}

.categories-pratique {
  display: inline-flex;
  flex-wrap: wrap;
}

.categories-pratique-L-E .categorie-pratique {
  margin: 10px 10px;
  width: 35%;
}

.categories-pratique-C .categorie-pratique {
  margin: 10px 0px;
  width: 33%;
}

.categories-pratique-V .categorie-pratique {
  margin: 10px 7px;
  max-width: min-content;
}

.card-radio-offre .card-body {
  padding: 1.25rem 1rem;
}
</style>
